import axios from "axios";
import  LoginService  from './../services/auth-service'

const handleUnauthorized = () => {
  LoginService.deleteAccessToken();
  window.location.href = process.env.REACT_APP_LOGOUT_URL
};

axios.interceptors.request.use(
  config => {
   const token = LoginService.getAccessToken();
   if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
   }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    const isLoginRequest =originalRequest.url.includes('authenticate');
    if (error.response && error.response.status === 401 && !isLoginRequest) {
      handleUnauthorized()
    }
    return Promise.reject(error);
  }
);